import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sessionHelper } from '@/utils'

export const lookupService = {
    getLookupRoles, 
    getAllPermissions, 
    getLookupUsers,
    getAllModulePermissions,
    getAllCompanySizes,
    getAllLocations,
    getAllCompanies,
    getAllCompanyTypes,
    getOwnPackages,
    getOwnServices,
    getOwnCompanyLocations,
    getOwnCompanyMenus,
    getOwnCheckPoints,
    getLookupLabels,
    getLookupReports,
    getLookupPaymentMethods,
    getLookupPublicPaymentMethods,
    getLookupTaxes,
    getLookupVehicleModel,
    getLookupServiceTemplates,

    //new 
    getPublicCompany,
};

const MODULE = {
    LOOKUP: 'lookup',
    ROLES: 'roles', 
    PERMISSIONS: 'permissions', 
    USERS: 'users',
    LOCATIONS: 'locations', 
    CUSTOMERS: 'customers', 
    STAFF_TYPES: 'staff-types',
    STAFFS: 'staffs', 
    WORKSHOPS: 'workshops', 
    WORKSHOP_TYPES: 'workshop-types',
    LANGUAGES: 'languages',
    COMPANY_SIZES: 'company-sizes',
    COMPANIES: 'own-companies',
    PACKAGES: 'own-packages',
    SERVICES: 'own-services',
    ALL_COMPANIES: 'companies',
    SERVICE_TYPES: 'service-types',
    OWN_COMPANY_LOCATIONS: 'own-locations',
    OWN_COMPANY_MENUS: 'company-menus',
    COMPANY_LOCATIONS: 'company-locations',
    MENUS: 'company-menus',
    MENU_SERVICES: 'menu-services',
    ALL_PACKAGES: 'packages',
    ALL_CHECK_POINTS: 'check-points',
    OWN_CHECK_POINTS: 'own-check-points',
    LABELS: 'labels',
    OWN_REPORTS: 'own-reports',
    REPORTS: 'reports',
    PUBLIC_PAYMENT_METHODS: 'reppublic-payment-methodsorts',
    TAXES: 'taxes',
    PAYMENT_METHODS: 'payment-methods',
    VEHICLE_MODELS: 'vehicle-models',
    SERVICE_TEMPLATES: 'service-templates',
    PUBLIC_COMPANIES: 'company-registers',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v2'

export function getLookupRoles() {
    const requestOptions = {
      params: {
        is_active: 1
      }
    }
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.ROLES}`, requestOptions)
}

export function getAllPermissions() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PERMISSIONS}`)
}

export function getLookupUsers() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.USERS}`)
}

export function getAllModulePermissions() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/module-permissions`)
}

export function getAllCompanySizes() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.COMPANY_SIZES}`)
}

export function getAllLocations() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.LOCATIONS}`)
}

export function getAllCompanyTypes() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.SERVICE_TYPES}`)
}

export function getAllCompanies() {
  if(sessionHelper.getUserType() == "ADMIN") {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.ALL_COMPANIES}`)
  }
  else {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.COMPANIES}`)
  }
}

export function getOwnPackages() {
  if(sessionHelper.getUserType() == "ADMIN") {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.ALL_PACKAGES}`)
  }
  else {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PACKAGES}`)
  }
}

export function getOwnServices() {
  if(sessionHelper.getUserType() == "ADMIN") {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.MENU_SERVICES}`)
  }
  else {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.SERVICES}`)
  }
}

export function getOwnCompanyLocations() {
  if(sessionHelper.getUserType() == "ADMIN") {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.COMPANY_LOCATIONS}`)
  }
  else {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.OWN_COMPANY_LOCATIONS}`)
  }
}

export function getOwnCheckPoints() {
  if(sessionHelper.getUserType() == "ADMIN") {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.ALL_CHECK_POINTS}`)
  }
  else {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.OWN_CHECK_POINTS}`)
  }
}

export function getOwnCompanyMenus() {
  if(sessionHelper.getUserType() == "ADMIN") {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.MENUS}`)
  }
  else {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.OWN_COMPANY_MENUS}`)
  }
}

export function getLookupLabels() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.LABELS}`)
}

export function getLookupReports() {
  if(sessionHelper.getUserType() == "ADMIN") {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.REPORTS}`)
  }
  else {
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.OWN_REPORTS}`)
  }
}

export function getLookupPaymentMethods() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PAYMENT_METHODS}`)
}

export function getLookupPublicPaymentMethods() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PUBLIC_PAYMENT_METHODS}`)
}

export function getLookupTaxes() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.TAXES}`)
}

export function getLookupVehicleModel() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.VEHICLE_MODELS}`)
}

export function getLookupServiceTemplates() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.SERVICE_TEMPLATES}`)
}

export function getPublicCompany() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PUBLIC_COMPANIES}`)
}